import { useState } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Slider, TextField } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { RewardsSelectionCard } from "../RewardsSelectionCard";
import { useRewardsSection } from "./hooks/useRewardsSection";
import styles from "./styles.module.scss";

export const RewardsSection = (props) => {
  const { t, formatFiatCurrency } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "RewardsSection");

  const {
    context: {
      isLoading,
      rewardsSelected,
      accountBalanceInPoints,
      accountBalanceInCash,
      maxToPayInPoints,
      maxToPayInCash,
      rewardsPayInPoints,
      rewardsPayInCash,
    },
    handlers: { onChange, onValueCommit },
  } = useRewardsSection();

  const [isEditingInputBox, setIsEditingInputBox] = useState(false);

  if (
    !isLoading &&
    (accountBalanceInPoints === 0 || accountBalanceInPoints == null)
  ) {
    return null;
  }

  return (
    <RewardsSelectionCard
      selected={rewardsSelected}
      footnote={
        rewardsSelected && (
          <>
            <div className={cn("divider")} />
            <div className={cn("points-input-section")}>
              <span className={cn("points-selection-title")}>
                {t("rewards.pointsInputLabel", {
                  totalPoints: maxToPayInPoints?.toLocaleString(),
                  cash: formatFiatCurrency(maxToPayInCash),
                })}
              </span>
              <div className={cn("slider-input")}>
                <Slider
                  min={0}
                  max={maxToPayInPoints}
                  value={[rewardsPayInPoints]}
                  onValueChange={(val) => {
                    onChange(val[0]);
                  }}
                  onValueCommit={(val) => {
                    onValueCommit(val[0]);
                  }}
                />
                <div className={cn("range-label")}>
                  <span>0</span>
                  <span>{maxToPayInPoints?.toLocaleString()}</span>
                </div>
              </div>
              <TextField
                label=""
                value={
                  isEditingInputBox
                    ? rewardsPayInPoints?.toLocaleString()
                    : `${rewardsPayInPoints?.toLocaleString()} (${formatFiatCurrency(
                        rewardsPayInCash
                      )})`
                }
                className={cn("text-field")}
                onChange={onChange}
                onFocus={() => setIsEditingInputBox(true)}
                onBlur={() => {
                  setIsEditingInputBox(false);
                  onValueCommit(rewardsPayInPoints);
                }}
              />
            </div>
          </>
        )
      }
      {...props}
    >
      <div className={cn("card-description")}>
        <span className={cn("card-title")}>{t("rewards.card.title")}</span>
        <span className={cn("card-reward-balance")}>
          {t("rewards.card.pointsBalance", {
            totalPoints: accountBalanceInPoints?.toLocaleString(),
            cash: formatFiatCurrency(accountBalanceInCash),
          })}
        </span>
      </div>
    </RewardsSelectionCard>
  );
};
